import React, { useContext } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { Behavior } from '@prisjakt/ui/text';
import { TitleSmallText } from '@prisjakt/ui/text/variants';
import { PriceListFilterContext } from 'src/areas/product/price-list-filter-context';
import { getFractalRepresentation, getSizeTitle } from './utils';
import { DropdownButtonText } from './styles';

export const SizeVariantsButtonLabel = () => {
  const { t, market } = useAppContext();
  const { selectedSizeVariants } = useContext(PriceListFilterContext);
  const title = getSizeTitle(t, market);
  const selectedVariants =
    (selectedSizeVariants?.length &&
      selectedSizeVariants
        .sort()
        .map(x => getFractalRepresentation(x))
        .join(', ')) ??
    t('product', 'variants.all');
  const buttonText = `${title}: ${selectedVariants}`;

  return (
    <DropdownButtonText behavior={Behavior.OnelineEllipsis}>
      <TitleSmallText>{buttonText}</TitleSmallText>
    </DropdownButtonText>
  );
};
